module.exports = __webpack_public_path__ + "img/22.628fcf06.png";